export default __webpack_public_path__ + "images/234c5d1f32d08f9bad40b0ba48d726d9.png";